var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { TemplateService } from "~/services/domain-service/template.service";
var CollectionExecutionModule = namespace('collection-execution');
var SpeechContent = /** @class */ (function (_super) {
    __extends(SpeechContent, _super);
    function SpeechContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overduePeriod = '';
        _this.templateDataSet = [];
        _this.model = {
            templateId: "",
            templateContent: ""
        };
        return _this;
    }
    SpeechContent.prototype.refresh = function () {
        var _this = this;
        var form = this.$refs['form'];
        form.resetFields();
        this.caseOperatorPageService.queryCaseInfo(this.caseId).subscribe(function (data) {
            _this.overduePeriod = "M" + data.overduePeriod;
        });
    };
    SpeechContent.prototype.onOverduePeriod = function (val) {
        var _this = this;
        if (!val) {
            return;
        }
        var request = {
            overduePeriod: val && Number.parseInt(val.substr(1)) >= 37 ? 'N37' : val,
            templateCategory: "SPEECH"
        };
        this.templateService.getTemplateByOverduePeriod(request).subscribe(function (data) { return _this.templateDataSet = data || []; });
    };
    SpeechContent.prototype.onTemplateChange = function (templateId) {
        if (!templateId) {
            this.model.templateContent = '';
            return;
        }
        var temp = this.templateDataSet.find(function (v) { return v.id === templateId; });
        this.model.templateContent = temp.templateContent;
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], SpeechContent.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], SpeechContent.prototype, "templateService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], SpeechContent.prototype, "caseId", void 0);
    __decorate([
        Watch("overduePeriod")
    ], SpeechContent.prototype, "onOverduePeriod", null);
    SpeechContent = __decorate([
        Component({})
    ], SpeechContent);
    return SpeechContent;
}(Vue));
export default SpeechContent;
